import React, { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import Header from "../../components/admin/Header";
import Sidebar from "../../components/admin/Sidebar";
import "./AdminLayout.css";

function AdminLayout() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  // Guard: if there's no token, bounce straight to the login page
  // instead of silently rendering admin pages with no logged-in user.
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <div className="admin-layout">

      <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} />

      <div className="main-area">
        <Header toggleSidebar={toggleSidebar} />

        <div className="main-content">
          <Outlet />
        </div>
      </div>

    </div>
  );
}

export default AdminLayout;